import axios from 'axios';
import { getAdminToken, removeAdminToken } from './auth';

// Local admin API client - using the admin backend URL
const adminApi = axios.create({
  baseURL: process.env.REACT_APP_LOCAL_ADMIN_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add authorization token
adminApi.interceptors.request.use(
  (config) => {
    const token = getAdminToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle unauthorized responses
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token is invalid, remove it and redirect to login
      removeAdminToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default adminApi;